import { Navigate, createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";

import { AuditLogPage, parseAuditSearch, type AuditFilterState } from "@/features/audit-log";
import { hasAdminRole, useAuth } from "@/shared/auth";

function AuditLogRoute(): JSX.Element {
  const { user } = useAuth();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  // Direct-URL guard: the backend requires the admin role on every audit
  // endpoint (see api/openapi.yaml, tag "audit"); this only spares a
  // non-admin the flash of a page whose requests will all 403.
  if (!hasAdminRole(user)) {
    return <Navigate to="/" />;
  }
  return (
    <AuditLogPage
      urlFilter={search}
      onUrlFilterChange={(next) => void navigate({ search: next, replace: true })}
    />
  );
}

export const Route = createFileRoute("/_authenticated/audit-log")({
  validateSearch: (raw: Record<string, unknown>): AuditFilterState =>
    parseAuditSearch(raw as Record<string, string | undefined>),
  component: AuditLogRoute,
});
